export enum PagePath {
  // account
  accountConfig = '/account/*',
  accountBase = '/account',
  accountLogin = '/login',
  accountRegister = '/register',
  
  accountSetPassword = '/set-password',
  accountForgotPassword = '/forgot-password',
  accountResetPassword = '/reset-password',
  accountVerifyEmail = '/verify-email',
  accountActivate = '/activate',

  // analysis
  analysisConfig = '/analysis/*',
  analysisBase = '/analysis',

  analysisPendingAssessments = '/pending-assessments',
  analysisPendingAssessmentsAssessment = '/pending-assessments/:assessmentSlug',

  analysisAssessment = '/:assessmentSlug',

  analysisFrequencyOfUse = '/frequency-of-use',
  analysisSelfAssessment = '/frequency-of-use/self-assessment',

  analysisRateYourPeersSkills = '/rate-your-peers-skills',
  analysisPeerSkillsAssessment = '/rate-your-peers-skills/peer-skills-assessment',
  analysisPeerSkillsAssessmentRating = '/rate-your-peers-skills/peer-skills-assessment/:ratingSlug',

  analysisQuestionnaires = '/questionnaires',
  analysisQuestionnaire = '/questionnaires/:questionnaireSlug',

  analysisChooseYourCareerPaths = '/choose-your-career-paths',
  analysisRateYourSkills = '/choose-your-career-paths/rate-your-skills',
  analysisRateYourSkillsRating = '/choose-your-career-paths/rate-your-skills/:ratingSlug',

  analysisInterimDownload = '/report',

  // learning journey
  learningJourneyConfig = '/learning-journey/*',
  learningJourneyBase = '/learning-journey',
  learningJourneyCoreSkillsMap = '/core-skills-map',
  learningJourneySkill = '/skill/:skillSlug',
  learningJourneyYearSkill = '/year-skill/:skillSlug',
  learningJourneyAssignedSkill = '/assigned-skill/:skillSlug',
  learningJourneyCourseReflections = '/course-reflections',
  learningJourneyAdditionalLearning = '/additional-learning',
  learningJourneyCertificates = '/certificates',

  // your career
  yourCareerConfig = '/your-career/*',
  yourCareerBase = '/your-career',
  yourCareerRole = '/:roleSlug',

  // your assessments
  yourAssessmentsConfig = '/your-assessments/*',
  yourAssessmentsBase = '/your-assessments',
  yourAssessmentsAssessment = '/:assessmentSlug',

  // user management
  userManagementConfig = '/user-management/*',
  userManagementBase = '/user-management',
  userManagementDepartments = '/:companySlug/departments',
  userManagementDepartmentTeams = '/:companySlug/departments/:departmentSlug/teams',
  userManagementDepartmentPeople = '/:companySlug/departments/:departmentSlug/people',
  userManagementTeams = '/:companySlug/teams',
  userManagementTeamPeople = '/:companySlug/teams/:teamSlug/people',
  userManagementPeople = '/:companySlug/people',
  userManagementPeopleBulkUpload = '/:companySlug/people/bulk-upload',
  userManagementTags = '/:companySlug/tags',
  userManagementSettings = '/:companySlug/settings',

  // analytics
  analyticsConfig = '/analytics/*',
  analyticsBase = '/analytics',
  analyticsOverview = '/:companySlug/overview',
  analyticsComparisonTools = '/:companySlug/comparison-tools',
  analyticsDepartments = '/:companySlug/departments',
  analyticsDepartment = '/:companySlug/departments/:departmentSlug',
  analyticsTeams = '/:companySlug/teams',
  analyticsTeam = '/:companySlug/teams/:teamSlug',
  analyticsPeople = '/:companySlug/people',
  analyticsPerson = '/:companySlug/people/:personSlug',
  analyticsRoles = '/:companySlug/roles',
  analyticsRole = '/:companySlug/roles/:roleSlug',
  analyticsRolePerson = '/:companySlug/roles/:roleSlug/:personSlug',
  analyticsSkills = '/:companySlug/skills',
  analyticsSkill = '/:companySlug/skills/:skillSlug',
  analyticsSkillSubType = '/:companySlug/skills/:skillSubTypeSlug/:skillSlug',
  analyticsAssessments = '/:companySlug/assessments',
  analyticsAssessment = '/:companySlug/assessments/:assessmentSlug',
  analyticsAssessmentPerson = '/:companySlug/assessments/:assessmentSlug/:personSlug',
  analyticsEngagement = '/:companySlug/engagement',
  analyticsReportTemplates = '/:companySlug/report-templates',
  analyticsReportTemplate = '/:companySlug/report-templates/:reportSlug',
  analyticsReportTemplateName = '/:companySlug/report-templates/:reportSlug/:reportName',

  // assessment management
  assessmentManagementConfig = '/assessment-management/*',
  assessmentManagementBase = '/assessment-management',
  assessmentManagement = '/:companySlug',
  assessmentManagementCreate = '/:companySlug/create',
  assessmentManagementCreateRatingAssessment = '/:companySlug/create/rating-assessment',
  assessmentManagementCreateGroupAssessment = '/:companySlug/create/group-assessment',
  assessmentManagementCreateFOPAssessment = '/:companySlug/create/fop-assessment',
  assessmentManagementCreateQuestionnaireAssessment = '/:companySlug/create/questionnaire-assessment',
  assessmentManagementViewRatingAssessment = '/:companySlug/view/rating-assessment/:assessmentSlug',
  assessmentManagementEditRatingAssessment = '/:companySlug/edit/rating-assessment/:assessmentSlug',
  assessmentManagementEditActiveRatingAssessment = '/:companySlug/view/rating-assessment/:assessmentSlug/edit',
  assessmentManagementEditGroupAssessment = '/:companySlug/edit/group-assessment/:assessmentSlug',
  assessmentManagementEditQuestionnaireAssessment = '/:companySlug/edit/questionnaire-assessment/:assessmentSlug',
  assessmentManagementEditFOPAssessment = '/:companySlug/edit/fop-assessment/:assessmentSlug',
  assessmentManagementAssignees = '/:companySlug/assignees/:assessmentSlug', // TODO: remove once all flows updated

  // learning management
  learningManagementConfig = '/learning-management/*',
  learningManagementBase = '/learning-management',
  learningManagementCourseMapping = '/:companySlug',
  learningManagementCourseMappingCourse = '/:companySlug/:courseSlug',
  learningManagementCourse = '/:companySlug/course/:courseSlug',

  // report management
  reportManagement = '/report-management/:companySlug',

  // role & skills management
  roleSkillManagementConfig = '/role-skill-management/*',
  roleSkillManagementBase = '/role-skill-management',

  roleSkillManagementAllRoles = '/:companySlug/all-roles',
  roleSkillManagementWizard = '/:companySlug/wizard',
  roleSkillManagementWizardUpdate = '/:companySlug/wizard/update/:roleSlug',

  roleSkillManagementWizardKeplerAI = '/:companySlug/wizard/kepler-ai',
  roleSkillManagementWizardCustomRole = '/:companySlug/wizard/custom-role',
  roleSkillManagementWizardImportRole = '/:companySlug/wizard/import-role',

  roleSkillManagementAllSkills = '/:companySlug/all-skills',

  roleSkillManagementSkillCategories = '/:companySlug/skill-categories',
  roleSkillManagementSkillCategoriesCreate = '/:companySlug/skill-categories/create',
  roleSkillManagementSkillCategoriesEdit = '/:companySlug/skill-categories/edit/:skillCategorySlug',
  roleSkillManagementSkillCategoriesView = '/:companySlug/skill-categories/view/:skillCategorySlug',

  roleSkillManagementCreateRole = '/:companySlug/create',
  roleSkillManagementEditRole = '/:companySlug/edit/:roleSlug',
  roleSkillManagementImportRole = '/:companySlug/import/:roleSlug',
  roleSkillManagementCompanyRole = '/:companySlug/company/:roleSlug',
  roleSkillManagementGlobalRole = '/:companySlug/global/:roleSlug',

  // ai management
  aiManagementConfig = '/ai-management/*',
  aiManagementBase = '/ai-management',
  aiManagementAgents = '/:companySlug/agents',
  aiManagementAgent = '/:companySlug/agents/:agentTypeName',
  aiManagementContexts = '/:companySlug/contexts',
  aiManagementContext = '/:companySlug/contexts/:contextId',
  aiManagementInformationSearch = '/:companySlug/information-search',
  aiManagementChat = '/:companySlug/chat',


    // freemium pages
  freemiumUserManagementConfig = '/users/*',
  freemiumUserManagementBase = '/users',
  freemiumUserManagementDepartmentPeople = '/:companySlug/departments/:departmentSlug/people',
  freemiumUserManagementPeople = '/:companySlug/people',
  freemiumUserManagementPeopleBulkUpload = '/:companySlug/people/bulk-upload',
  freemiumAssessment = '/company/assessment-management',

  // other
  onboarding = '/onboarding',
  profile = '/profile',
  companies = '/companies',
  dashboard = '/dashboard',
  yourSkills = '/your-skills',
  version = '/version',

  // error
  error = '/error/:type/:code',
  errorRouting404 = '/error/routing/404',

  // root
  root = '/',
  rootWildcard = '/*',
}

export enum Mode {
  AdminDashboard = 'AdminDashboard',
  UserDashboard = 'UserDashboard',
}

